import React, { useState, useEffect } from 'react';
import './makepayment.css';
import Administration from './administration';
import { useParams } from 'react-router-dom';
import monday from '../clientviews/billingmanagement/caisiere/pictures/momo.png';
import money from '../clientviews/billingmanagement/caisiere/pictures/Money.png';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../service/caller';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

function Payment({ onNext, onBack, patientData }) {
    const [paymentMethod, setPaymentMethod] = useState('');
    const [admissiondata, setAdmissionData] = useState(null);
    const [cashOption, setCashOption] = useState('total'); // 'total' ou 'partial'
    const [cashAmount, setCashAmount] = useState('');
    const [phone, setPhoneNumber] = useState('');

    const handlePaymentMethodSelect = (method) => {
        setPaymentMethod(method);
    };

    const [paid, setPaid] = useState(false);

    useEffect(() => {
        const fetchTraitmentData = async () => {
            try {
                const response = await api.get(`api/rooms/hospitalization/totalfee/${patientData._id}`);
                setAdmissionData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchTraitmentData();
    }, [patientData]);

    if (!admissiondata) {
        return <div>Chargement des données...</div>;
    }

    const { admission, room, grandTotal, treatmentPlan } = admissiondata;
    const amountToPay = grandTotal;


    const handlePayment = () => {
        setPaid(true);
    };
    return (
        <>
            <ToastContainer />

            <div className="pay-frame">
                <h1 className="pay-header">Paiement</h1>
                
                {/* Résumé de la facture */}
                <div className="pay-facture-summary">
                    <div className="pay-info-row">
                    <span className="pay-info-label">ID Patient :</span>
                    <span className="pay-info-value">{patientData.patientId?.patientId}</span>
                    </div>
                    <div className="pay-info-row">
                    <span className="pay-info-label">Nom et Prénom :</span>
                    <span className="pay-info-value">{patientData.patientId?.firstname} {patientData.patientId?.lastname}</span>
                    </div>
                    <div className="pay-info-row">
                    <span className="pay-info-label">Résumé :</span>
                    <span className="pay-info-value">Facture de séjour, soins et médicaments</span>
                    </div>
                    <div className="pay-info-row pay-total">
                    <span className="pay-info-label">Montant total :</span>
                    <span className="pay-info-value pay-amount">{grandTotal} {admission.hospitalId?.hospital_currency}</span>
                    </div>
                </div>
                
                {/* Méthodes de paiement */}
                <div className="pay-section-title">Choisissez une méthode de paiement</div>
                <div className="pay-methods">
                    <label className="pay-method-option">
                    <input
                        type="radio"
                        name="payment-method"
                        value="mobile-money"
                        checked={paymentMethod === 'mobile-money'}
                        onChange={() => handlePaymentMethodSelect('mobile-money')}
                        className="pay-radio-input"
                    />
                    <div className="pay-method-content">
                        <img src={monday} alt="Monday Money" className="pay-method-icon" />
                        <span className="pay-method-name">Mobile Money</span>
                    </div>
                    </label>
                    
                    <label className="pay-method-option">
                    <input
                        type="radio"
                        name="payment-method"
                        value="cash"
                        checked={paymentMethod === 'cash'}
                        onChange={() => handlePaymentMethodSelect('cash')}
                        className="pay-radio-input"
                    />
                    <div className="pay-method-content">
                        <img src={money} alt="Cash" className="pay-method-icon" />
                        <span className="pay-method-name">Espèces</span>
                    </div>
                    </label>
                </div>

                {/* Section spécifique au Mobile Money */}
                {paymentMethod === 'mobile-money' && (
                    <div className="pay-mobile-section">
                    <label className="pay-input-label">
                        Entrez votre numéro de téléphone
                        <PhoneInput
                        country={'bj'}
                        value={phone}
                        onChange={(value) => setPhoneNumber(value)}
                        name="phone"
                        containerClass="pay-phone-container"
                        inputClass="pay-phone-input"
                        buttonClass="pay-phone-dropdown"
                        />
                    </label>
                    </div>
                )}

                {/* Section spécifique au paiement en espèces */}
                {paymentMethod === 'cash' && (
                    <div className="pay-cash-section">
                    <div className="pay-cash-options">
                        <label className="pay-cash-option">
                        <input
                            type="radio"
                            name="cash-option"
                            value="total"
                            checked={cashOption === 'total'}
                            onChange={() => setCashOption('total')}
                            className="pay-radio-input"
                        />
                        <span className="pay-option-text">
                            Payer la totalité ({amountToPay} XOF)
                        </span>
                        </label>
                        
                        <label className="pay-cash-option pay-option-disabled">
                        <input
                            type="radio"
                            name="cash-option"
                            value="partial"
                            checked={cashOption === 'partial'}
                            onChange={() => setCashOption('partial')}
                            disabled
                            className="pay-radio-input"
                        />
                        <span className="pay-option-text">
                            Paiement partiel
                        </span>
                        </label>
                    </div>

                    <div className="pay-amount-container">
                        <label className="pay-input-label">
                        Montant à payer
                        <input
                            type="number"
                            min="0"
                            max={amountToPay}
                            value={cashAmount}
                            onChange={(e) => setCashAmount(e.target.value)}
                            className="pay-amount-input"
                            placeholder={`Entrez un montant jusqu'à ${amountToPay}`}
                        />
                        </label>
                    </div>
                    </div>
                )}

                {/* Boutons d'action */}
                <div className="pay-actions">
                    <button 
                    className="pay-button pay-submit"
                    onClick={() => onNext(7)}
                    >
                    Finaliser la décharge du patient
                    </button>
                    
                    {onBack && (
                    <button 
                        className="pay-button pay-back"
                        onClick={() => onNext(1)}
                    >
                        Retour
                    </button>
                    )}
                </div>
            </div>
        </>

    );
}

export default Payment